import React from 'react'

const data = [
  {
    img: '/assets/images/about-trust-1.webp',
    head: "Built on Trust",
    text: "At Dox and Box, trust is not a feature; it is the foundation of everything we do. We bring deep expertise in records management, compliance, enterprise information governance to ensure your data is always protected and cared for."
  },
  {
    img: '/assets/images/about-trust-2.webp',
    head: "Designed for Agility",
    text: "We believe document management should not slow businesses down; it should accelerate them. Our solutions are designed to eliminate operational friction through streamlined workflows, intelligent indexing, easy retrieval systems."
  },
  {
    img: '/assets/images/about-trust-3.webp',
    head: "Always Reliable",
    text: "From large-scale document archiving to on-demand retrieval and digitization, Dox and Box delivers consistent and dependable support. Our hybrid service model combines expert-managed operations with self-service capabilities."
  },
]
export default function AboutTrust() {
  return (
    <>
      <section className="about-trust-area">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-9">
              <h3 className="heading center-heading">A Trusted Partner in Intelligent Document Management</h3>
              <p className='sub-heading'>Thousands of enterprises rely on Dox and Box to manage critical documents with precision, security, consistency.</p>
            </div>

            {data?.map((item, ind) => (
              <div key={ind} className="col-lg-4 col-md-6">
                <div className="about-trust-box">
                  <img src={item?.img} alt="logo" />
                  <span>{item?.head}</span>
                  <p>{item?.text}</p>
                </div>
              </div>
            ))}

          </div>
        </div>
      </section>
    </>
  )
}
